module.exports = __webpack_public_path__ + "components/home-header/static/header-6--medium@2x-c32a0b493f41994ed3eeca1a205f5902.jpg";